import { useEffect, useState } from 'react';

/**
 * true mientras el elemento está a la vista (o cerca, con `margen`). Sirve para pausar animaciones que no se ven.
 * @param {import('react').RefObject<HTMLElement>} ref
 * @param {string} [margen]  rootMargin del IntersectionObserver
 * @returns {boolean}
 */
export default function useEnVista(ref, margen = '100px 0px') {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver !== 'function') return undefined;
    const io = new IntersectionObserver(([e]) => setVisible(e.isIntersecting), { rootMargin: margen });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, margen]);
  return visible;
}
